import { decode } from 'html-entities'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Avatar from 'srcReact/components/common2/Avatar'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'

const WorkplaceMemberGroupCard = ({ group, groupId, handleClick }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const showUserLightModal = (modalUser) => {
    const lp = new LightProfileProto()
    lp.userId = modalUser.id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }
  return (
    <a
      role='button'
      tabIndex='0'
      id={groupId}
      className={styles.workplaceMemberGroupCardWrapper}
      onClick={() => {
        if (handleClick) {
          handleClick(group)
        }
      }}>
      <div className={styles.picture}>
        {group?.group_cover ? (
          <img src={group?.group_cover} alt={decode(group?.group_name)} />
        ) : (
          <img src={require('srcReact/assets/images/background-default-mixr.jpg')} alt='default' />
        )}
      </div>

      <h2 className={styles.heading}>{decode(group?.group_name)}</h2>

      <div className={styles.staffPictures}>
        {group?.staff?.length > 0 &&
          group?.staff?.map((staff, i) => (
            <Avatar
              key={i}
              imgWrapperSize='small'
              userId={staff.id}
              profilePicture={staff.profile_picture}
              firstname={staff.firstname}
              lastname={staff.lastname}
              mimeType={staff.mime_type}
              originalTag={staff.original_tag}
              isOriginal={staff.is_original}
              containerCSS={styles.avatar}
              showImageAsDecorative={true}
              withExpertiseGroup={staff.with_expertise_group}
              onClickAction={() => showUserLightModal(staff)}
            />
          ))}
      </div>
    </a>
  )
}

export default WorkplaceMemberGroupCard
